// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610132005/js/" + chunkId + "." + {"44":"7078a963","225":"78746f24","481":"6a3614fd","486":"eed3f305","770":"4f94215e"}[chunkId] + ".0.1997832597839071.chunk.js";
};